import React, { useState, useEffect } from 'react'
import UpdateForm from './UpdateForm';
import { Typography } from '@mui/material';
import { Modal } from 'react-bootstrap'

export default function DiscoverRateScrapper() {
    const [lgShow, setLgShow] = useState(false);
    const [accessType, setAccessType] = useState('')

    //API call
    useEffect(() => {

        const loggedInUser = sessionStorage.getItem("user_token");
        const foundUser = JSON.parse(loggedInUser);

        if (foundUser.role === 'SuperAdmin') {

            setAccessType('Edit');

        }
        else {

            setAccessType(foundUser.access['RateSnapshot_Access Specifier']);
        }

    }, []);

    return (
        <>

            <div className="row">
                <div className="row my-3 ">
                    <div className="col-md-6">
                        <Typography className="mx-3" variant='h4' sx={{ pb: 3 }}>
                           Economy Bookings Rate Scrapper {accessType === 'View' && "/ View Only Mode"}
                        </Typography>
                    </div>

                   
                </div>
            </div>

            {accessType === 'View' ? <UpdateForm accessType={accessType} /> : <UpdateForm />}
        </>
    );
}